import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { FormSection, FieldArray } from 'redux-form';
import Button from 'jbc-front/components/Button';
import { Section } from 'jbc-front/components/Form';
import scrollSpy, { AnchorTarget } from 'jbc-front/components/ScrollSpy';
// import FormErrors from 'jbc-front/components/FormErrors';
import { ErrorsSection } from 'src/components';
import Affix from 'jbc-front/components/Affix';
import ListGroup from 'jbc-front/components/ListGroup';
import { Anchor } from 'src/components';
import ClientSection from '../containers/ClientSection';
import BranchSection from './BranchSection';
import CompanyImageSection from '../containers/CompanyImageSection';
import { FormSubmitBtn } from 'src/buttons';
import styles from './CompanyForm.scss';
import { useTranslation } from 'react-i18next';

const DetailCompanyForm = ({ handleSubmit, submit, isNewForm, errors, pristine, submitting, showUrl }) => {
  const { t } = useTranslation();
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <ErrorsSection errors={errors} />

      <AnchorTarget name="CompanyInformation" />
      <Section title={t('features.Clients.components.CompanyForm.office_information')}>
        <FormSection name="client">
          <ClientSection isNewForm={isNewForm} />
        </FormSection>
      </Section>

      <AnchorTarget name="BranchInformation" />
      <Section title={t('features.Clients.components.CompanyForm.branch_information')}>
        <div>
          <FieldArray name="clientBranch" component={BranchSection} isNewForm={isNewForm} />
        </div>
      </Section>

      <AnchorTarget name="CompanyImage" />
      <Section title={t('features.Clients.components.CompanyForm.image_information')}>
        <FormSection name="client">
          <CompanyImageSection isNewForm={isNewForm} />
        </FormSection>
      </Section>

      <div className="u-ta-c u-mt20">
        <Button as="a" href={showUrl} className="u-mr20">
          {t('features.Clients.components.CompanyForm.cancel')}
        </Button>
        <Button disabled={pristine || submitting} onClick={submit} primary>
          {t('features.Clients.components.CompanyForm.save')}
        </Button>
      </div>
    </form>
  )
}

const CompanyForm = scrollSpy(
  ({ current, submitting, pristine, submit, handleSubmit, isNewForm, errors, dispatch, image, showUrl, initialValues, ...rest }) => {
    const { t } = useTranslation();
    return (
      <div>
        <div className="l-flex">
          <div className="l-flex6-sub">
            <Affix offset={271} className={styles.navi}>
              <ListGroup>
                <Anchor name="CompanyInformation" current={current}>
                  {t('features.Clients.components.CompanyForm.office_information')}
                </Anchor>
                <Anchor name="BranchInformation" current={current}>
                  {t('features.Clients.components.CompanyForm.branch_information')}
                </Anchor>
                <Anchor name="CompanyImage" current={current}>
                  {t('features.Clients.components.CompanyForm.image_information')}
                </Anchor>
                <ListGroup.Item>
                  <FormSubmitBtn
                    {...{ submitting, submit }}
                    text={t('features.Clients.components.CompanyForm.save')}
                    widthWide
                    disabled={submitting || pristine}
                  />
                </ListGroup.Item>
              </ListGroup>
            </Affix>
          </div>
          <div className="l-flex6-main">
            <DetailCompanyForm {...{ handleSubmit, submit, isNewForm, errors, pristine, submitting, showUrl }} {...rest} />
          </div>
        </div>
      </div>
    )
  }
);

export default connect()(CompanyForm);